import { liveLog } from "@/lib/liveLog";

const isVisible = (el) => el && el.getClientRects().length > 0 && el.offsetParent !== null;

// Resolve the visible card for an article id (mobile/desktop grids both render).
export function findArticleCard(id) {
    const nodes = document.querySelectorAll(`[data-article-id="${id}"]`);
    for (const n of nodes) if (isVisible(n)) return n;
    return null;
}

export function waitForArticleCard(id, timeout = 5000) {
    return new Promise((resolve) => {
        const found = findArticleCard(id);
        if (found) return resolve(found);
        const done = (el) => { obs.disconnect(); clearTimeout(t); resolve(el); };
        const obs = new MutationObserver(() => { const el = findArticleCard(id); if (el) done(el); });
        obs.observe(document.body, { childList: true, subtree: true });
        const t = setTimeout(() => done(null), timeout);
    });
}

function stickyOffset() {
    const header = document.querySelector("header.site-header");
    return (header ? header.getBoundingClientRect().height : 0) + 16;
}

// Scroll the real scroll container so the card sits just under the sticky header.
export function scrollToCard(el, forced) {
    const scroller = (() => {
        let p = el.parentElement;
        while (p && p !== document.body) {
            const s = getComputedStyle(p);
            if (/(auto|scroll)/.test(s.overflowY) && p.scrollHeight > p.clientHeight) return p;
            p = p.parentElement;
        }
        return null;
    })();
    const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    const behavior = forced || (reduce ? "auto" : "smooth");
    if (scroller) {
        const top = el.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - 12;
        scroller.scrollTo({ top, behavior });
    } else {
        const top = el.getBoundingClientRect().top + window.scrollY - stickyOffset();
        window.scrollTo({ top: Math.max(0, top), behavior });
    }
}

export function highlightCard(el, ms = 3500) {
    el.classList.add("article-target-highlight");
    setTimeout(() => el.classList.remove("article-target-highlight"), ms);
}

export async function goToArticleCard(id) {
    let el = await waitForArticleCard(id);
    if (!el) { liveLog("goto.notfound", { id }); return false; }
    scrollToCard(el);
    const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    await new Promise((r) => setTimeout(r, reduce ? 80 : 700));
    // Re-align once: the card may have been re-rendered or pushed by late layout.
    el = findArticleCard(id) || el;
    const drift = Math.abs(el.getBoundingClientRect().top - stickyOffset());
    if (drift > 8) { scrollToCard(el, "auto"); await new Promise((r) => setTimeout(r, 60)); }
    highlightCard(el);
    liveLog("goto.ok", { id, drift: Math.round(drift) });
    return true;
}
